import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UtilService } from '../util.service';

@Injectable()
export class NgbTranslatedDatepicker extends NgbDatepickerI18n {
  constructor(
    private translate: TranslateService,
    private util: UtilService
  ) {
    super();
  }
  getWeekdayLabel(weekday: number): string {
    return this.util.getDayTranslation(weekday, this.translate.getDefaultLang() === 'de' ? 2 : 3);
  }

  getWeekLabel(): string {
    return '';
  }

  getMonthShortName(month: number): string {
    return this.util.getMonthTranslation(month, 3);
  }

  getMonthFullName(month: number): string {
    return this.util.getMonthTranslation(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
